import { StandardHeader } from './StandardHeader'

export default StandardHeader
